export default __webpack_public_path__ + "static/media/weight-chart.52f2d00a.png";